"use client";

import { twMerge } from "tailwind-merge";

import { SEARCH_PARAMS } from "@/globals";
import { BUTTON_STYLES } from "@/styles/buttons";
import { TYPO_STYLES } from "@/styles/typography";
import { WRAPPER_STYLES } from "@/styles/wrapper";

type SearchModuleNavigationProps = {
    initialSearchString: string;
    onClickFach?: () => void;
    onClickKlassenstufe: () => void;
    onClickSchulform: () => void;
};
export const SearchModuleNavigationView = ({
    onClickFach,
    onClickSchulform,
    onClickKlassenstufe,
    initialSearchString,
}: SearchModuleNavigationProps) => {
    const initialSearchParams = new URLSearchParams(initialSearchString);
    return (
        <div className={twMerge(WRAPPER_STYLES.HCenterLeft(), "gap-4 hidden sm:flex")}>
            {!initialSearchParams.has(SEARCH_PARAMS.faecher) && (
                <button className={BUTTON_STYLES.plain()} onClick={onClickFach}>
                    <span>Fach</span>
                    <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                        {String.fromCharCode(Number(`0xe916`))}
                    </span>
                </button>
            )}
            {!initialSearchParams.has(SEARCH_PARAMS.schularten) && (
                <button className={BUTTON_STYLES.plain()} onClick={onClickSchulform}>
                    <span>Schulform</span>
                    <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                        {String.fromCharCode(Number(`0xe916`))}
                    </span>
                </button>
            )}
            {!initialSearchParams.has(SEARCH_PARAMS.klassenstufen) && (
                <button className={BUTTON_STYLES.plain()} onClick={onClickKlassenstufe}>
                    <span>Klassenstufe</span>
                    <span className={twMerge(TYPO_STYLES.icon(), "text-2xl")}>
                        {String.fromCharCode(Number(`0xe916`))}
                    </span>
                </button>
            )}
        </div>
    );
};
